import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-swap-vertical-outline",
  "use": "icon-swap-vertical-outline-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" class=\"ionicon\" viewBox=\"0 0 512 512\" id=\"icon-swap-vertical-outline\"><title>Swap Vertical</title><path fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"32\" d=\"M464 208L352 96 240 208M352 113.13V416M48 304l112 112 112-112M160 398V96\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol